__turbopack_context__.v({
  "deepskyblue": "BlockSelect-module__EQx2xW__deepskyblue",
  "defaultSelect": "BlockSelect-module__EQx2xW__defaultSelect",
  "disabledStyle": "BlockSelect-module__EQx2xW__disabledStyle",
  "ghostwhite": "BlockSelect-module__EQx2xW__ghostwhite",
  "input": "BlockSelect-module__EQx2xW__input",
  "inputActive": "BlockSelect-module__EQx2xW__inputActive",
  "inputContainer": "BlockSelect-module__EQx2xW__inputContainer",
  "inputContainerNoLabel": "BlockSelect-module__EQx2xW__inputContainerNoLabel",
  "label": "BlockSelect-module__EQx2xW__label",
  "labelContainer": "BlockSelect-module__EQx2xW__labelContainer",
  "labelContainerFocused": "BlockSelect-module__EQx2xW__labelContainerFocused",
  "lightblue": "BlockSelect-module__EQx2xW__lightblue",
  "listBox": "BlockSelect-module__EQx2xW__listBox",
  "noOptions": "BlockSelect-module__EQx2xW__noOptions",
  "option": "BlockSelect-module__EQx2xW__option",
  "selectArrow": "BlockSelect-module__EQx2xW__selectArrow",
  "selectArrowFocus": "BlockSelect-module__EQx2xW__selectArrowFocus",
  "selectContainer": "BlockSelect-module__EQx2xW__selectContainer",
  "selectControl": "BlockSelect-module__EQx2xW__selectControl",
  "selectControlActive": "BlockSelect-module__EQx2xW__selectControlActive",
  "selectControlAriaDisabled": "BlockSelect-module__EQx2xW__selectControlAriaDisabled" + " " + "BlockSelect-module__EQx2xW__disabledStyle",
  "selectControlError": "BlockSelect-module__EQx2xW__selectControlError",
  "selectControlOutline": "BlockSelect-module__EQx2xW__selectControlOutline",
  "selectMenu": "BlockSelect-module__EQx2xW__selectMenu",
  "selected": "BlockSelect-module__EQx2xW__selected",
  "selectedNoLabel": "BlockSelect-module__EQx2xW__selectedNoLabel",
  "transparent": "BlockSelect-module__EQx2xW__transparent",
  "whitesmoke": "BlockSelect-module__EQx2xW__whitesmoke",
});
